module.exports = __webpack_public_path__ + "media/Loops 90 Keys.84d7e518.wav";